import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useEmployees() {
  const [employees, setEmployees] = useState([]);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/employees");
      setEmployees(data);
    } catch { /* ignore */ }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { employees, reload };
}
